import React from 'react';
import MH_logo1 from './MH_logo1.png'
import 'bootstrap/dist/css/bootstrap.css';
import { SocialMediaIconsReact } from 'social-media-icons-react';
function Header() {
    return(
        <div id='header-row' className="container-fluid container-dark rounded-bottom">
            <div className="row justify-content-center" type="header">
                <div className="col"></div>
                <div className="col">
                    <img className="mx-auto d-block h-logo" src={MH_logo1} fluid={true}></img>
                </div>
                <div className="col justify-content-end">
                    <div className='btn-toolbar rounded social-icons pt-2 pe-4' role={"toolbar"} aria-label='Social Icons'>
                        <SocialMediaIconsReact icon="facebook" iconColor='rgb(255, 203, 8)' borderWidth='0' url='https://www.facebook.com/meg.and.hugo' backgroundColor='rgb(65,64,66)' size='35' roundness='50' iconSize='5'/>
                        <SocialMediaIconsReact icon="instagram" iconColor='rgb(255, 203, 8)' borderWidth='0' url='https://www.instagram.com/meg.and.hugo/' backgroundColor='rgb(65,64,66)' size='35' roundness='50' iconSize='5'/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header